export default __webpack_public_path__ + "static/media/icon_home_top_lock.808543d1.svg";